import { render, staticRenderFns } from "./AthleteComparativeDataV2.vue?vue&type=template&id=7d4fbc1f&scoped=true&"
import script from "./AthleteComparativeDataV2.vue?vue&type=script&lang=ts&"
export * from "./AthleteComparativeDataV2.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteComparativeDataV2.vue?vue&type=style&index=0&id=7d4fbc1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4fbc1f",
  null
  
)

export default component.exports